/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：764
 */

var r = new Map()
r.set("no-undef", require(/* 1134 */"./1134"))
r.set("consistent-return", require(/* 1135 */"./1135/index"))
module.exports = r
